export default __webpack_public_path__ + "static/media/section2b-grid1img.a6f38850.svg";